import { Router } from "@angular/router";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Inject, Injectable } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  SocialStructure,
  SocialSubFeatures,
  SOCIAL_SUBFEATURES,
} from "../services/features-by-plan/interface/social";
import { FeaturesByPlanService } from "../services/features-by-plan/features-by-plan.service";
import { EventEmitter } from "events";
import { FileItem, FileUploader } from "ng2-file-upload";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { ToastrService } from "ngx-toastr";
import { GlobalVariable } from "../app.component";
import { DataService, Response } from "../dataService/data.service";
import { MediaFileModel } from "./social-create-edite-post/social-share-main/field-sections/social.model";
export type CollapseID = "gmb-sec" | "error-sec" | "bg-sec" | "share-sec";
export type CallToAction =
  | "none"
  | "book"
  | "order_online"
  | "buy"
  | "learn_more"
  | "signup"
  | "call_now";
@Injectable({
  providedIn: "root",
})
export class SocialService {
  private BASE_URL = GlobalVariable;
  editDraft = new Subject<any>();
  draft_Update = new Subject<any>();
  social_detail = new Subject<any>();
  onEditPost = new BehaviorSubject<any>(null);
  toggleCollapse: Subject<{ id: string; toggle: boolean }> = new Subject();
  private _postCount = new BehaviorSubject<{
    count: number;
    type: "SENT" | "DRAFT";
  }>(null);
  private _preview = new BehaviorSubject<{ data: any }>(null);
  private _previewContent = new BehaviorSubject<string>(null);
  public postCount$ = this._postCount.asObservable();
  public previewDetails$ = this._preview.asObservable();
  public previewContent$ = this._previewContent.asObservable();
  private _isUpdateImage = new BehaviorSubject<boolean>(null);
  public isUpdateImage$ = this._isUpdateImage.asObservable();
  public isImageUpdating: boolean = false;
  public closeCalendarModal$ = new BehaviorSubject<boolean>(null);
  private _changeSentPostView = new BehaviorSubject<boolean>(null);
  public changeSentPostView$ = this._changeSentPostView.asObservable();
  socialFeature: SocialStructure = {
    zceppa_template: [
      "feature_social",
      SOCIAL_SUBFEATURES.zceppa_template,
      "is_applicable",
    ],
    custom_template: [
      "feature_social",
      SOCIAL_SUBFEATURES.custom_template,
      "is_applicable",
    ],
    categories: ["feature_social", SOCIAL_SUBFEATURES.categories, "values"],
    background_type: [
      "feature_social",
      SOCIAL_SUBFEATURES.background_type,
      "is_applicable",
    ],
    share_to_customers: [
      "feature_social",
      SOCIAL_SUBFEATURES.share_to_customers,
      "values",
    ],
    post_analytics: [
      "feature_social",
      SOCIAL_SUBFEATURES.post_analytics,
      "is_applicable",
    ],
    multi_outlet_share: [
      "feature_social",
      SOCIAL_SUBFEATURES.multi_outlet_share,
      "is_applicable",
    ],
    social_download_report: [
      "feature_social",
      SOCIAL_SUBFEATURES.social_download_report,
      "is_applicable",
    ],
    social_widget: [
      "feature_social",
      SOCIAL_SUBFEATURES.social_widget,
      "is_applicable",
    ],
    social_review_share: [
      "feature_social",
      SOCIAL_SUBFEATURES.social_review_share,
      "is_applicable",
    ],
    social_review_share_frequency: [
      "feature_social",
      SOCIAL_SUBFEATURES.social_review_share_frequency,
      "is_applicable",
    ],
    social_review_share_value: [
      "feature_social",
      SOCIAL_SUBFEATURES.social_review_share,
      "values",
      ["Template", "Post"],
    ],
  };
  mediaUploader: FileUploader;
  dragDropImage: any;
  updatePreview$ = new Subject<any>();
  mediaFiles: MediaFileModel[] = [];
  isIncorrectAR: boolean = false;
  public DISABLE_CACHE = "?not-from-cache-please";
  private _isUploading = false;
  _imageDimension: { width: number; height: number };
  get outletId() {
    return this.storage.get("outlet_id");
  }
  set isUploading(isUploading: boolean) {
    this._isUploading = isUploading;
  }
  get isUploading() {
    return this._isUploading;
  }
  constructor(
    private featuresByPlan: FeaturesByPlanService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private toastrService: ToastrService,
    private HttpService: DataService,
    private router: Router
  ) {
    this.mediaUploader = new FileUploader({
      authToken: "Bearer " + this.storage.get("access_token"),
      autoUpload: true,
      allowedMimeType: [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/webp",
        "video/mp4",
      ],
    });

    this.mediaUploader.onProgressAll = (progress) => {
      this.isUploading = true;
    };
    this.mediaUploader.onCompleteAll = () => {
      this.isUploading = false;
    };
    this.mediaUploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.mediaUploader.onCompleteItem = (item, response: any, status: any) => {
      if (status === 201) {
        let data = JSON.parse(response);
        this.OnMediaTypeUpload({
          id: data.media_id,
          url: data.url,
          fileItem: item,
        });
      } else if (status === 206 || status == 422) {
        let data = JSON.parse(response);
        this.toastrService.error(data.message); // =
        this.isUploading = false;
      }
    };
    this.mediaUploader.onErrorItem = (item, response, status: any) => {
      console.error(response, status);
      this.isUploading = false;
    };
    this.mediaUploader.onWhenAddingFileFailed = (item: any, filter: any) => {
      this.isUploading = false;
      if (filter.name === "mimeType") {
        this.toastrService.error(
          "Error uploading the file. Wrong image format or file name"
        );
      }
      if (filter.name === "fileSize") {
        this.toastrService.error(
          "The file size is exceeding the maximum file size of " +
            this.mediaUploader.options.maxFileSize / 1024 / 1024 +
            " MB."
        );
      }
      if (filter.name === "queueLimit") {
        this.toastrService.error(
          `Only ${
            this.mediaUploader.options.queueLimit + this.mediaFiles.length
          } file can be uploaded.`
        );
      }
    };
  }

  public toastr(message: string, type: string) {
    if (type == "success") {
      this.toastrService.success(message);
    }
  }

  setTotalCount(post: { count: number; type: "SENT" | "DRAFT" }) {
    this._postCount.next(post);
  }

  setPreviewData(data: any) {
    this._preview.next(data);
  }

  setPreviewContent(data: string) {
    this._previewContent.next(data);
  }

  setUpdateImage(data: boolean) {
    this._isUpdateImage.next(data);
  }
  changeSentPostView(data: boolean) {
    this._changeSentPostView.next(data);
  }

  updatePreview() {
    this.updatePreview$.next(null);
  }

  onEditPostRedirect(post_id: string) {
    this.router.navigate([`social/edit/${post_id}`]);
  }
  get getMediaFilesLength() {
    return this.mediaFiles.length;
  }
  setFileUploadOption(fileOptions: {
    mediaType: string;
    maxFileSize: number;
    queueLimit: number;
  }) {
    this.mediaUploader.clearQueue();
    switch (fileOptions.mediaType) {
      case "IMAGE":
        this.mediaUploader.setOptions({
          url: `${this.BASE_URL.BASE_API_URL}${this.BASE_URL.SOCIAL_UPLOAD(
            this.outletId
          )}`,
          itemAlias: "social_image",
          additionalParameter: { upload_location: "SOCIAL" },
          maxFileSize: fileOptions.maxFileSize,
          queueLimit: fileOptions.queueLimit - this.getMediaFilesLength,
          allowedFileType: ["image"],
        });
        break;
      case "VIDEO":
        this.mediaUploader.setOptions({
          url: `${
            this.BASE_URL.BASE_API_URL
          }${this.BASE_URL.SOCIAL_VIDEO_UPLOAD(this.outletId)}`,
          itemAlias: "social_video",
          additionalParameter: { upload_location: "SOCIAL" },
          maxFileSize: fileOptions.maxFileSize,
          queueLimit: fileOptions.queueLimit - this.getMediaFilesLength,
          allowedFileType: ["video"],
        });
        break;
      default:
        break;
    }
  }

  private deleteMedia(mediaId: string, campaign_id: string) {
    return this.HttpService.deleteRequest({
      customApiUrl: this.BASE_URL.SOCIAL_MEDIA_DELETE(this.outletId, mediaId),
      source_id: campaign_id,
      source: "SOCIAL",
    });
  }
  onDeleteExistingMedia(
    mediaId: string,
    campaign_id: string,
    campaign_status: string
  ) {
    if (campaign_id && campaign_status.toUpperCase() == "PENDING") {
      this.deleteMedia(mediaId, campaign_id).subscribe((data) => {
        if (data.code === 200) {
          this.removeMediaFromList(mediaId);
        }
      });
    } else {
      this.removeMediaFromList(mediaId);
    }
  }
  onItemDelete(item: FileItem, media_id: string) {
    if (item) {
      // this.mediaUploader.removeFromQueue(item);
    }
    this.removeMediaFromList(media_id);
  }

  emptyMediaFields() {
    this.mediaFiles = [];
    this.isIncorrectAR = false;
    this.mediaUploader.clearQueue();
    this.updatePreview();
  }

  removeMediaFromList(mediaId: string) {
    this.mediaFiles = this.mediaFiles.filter((item) => item?.id !== mediaId);
    this.updatePreview();
  }

  get mediaIdList() {
    let mediaFiles = this.mediaFiles.map((item) => item?.id);
    return mediaFiles;
  }

  private _mediaTypeUpload(
    id: string,
    url: string,
    fileType: string,
    fileItem: FileItem | null
  ): MediaFileModel {
    return new MediaFileModel(id, url, fileType, fileItem);
  }
  private _getfileType(fileName: string) {
    let fileType = fileName && fileName.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png"].includes(fileType)) {
      fileType = "IMAGE";
    } else {
      fileType = "VIDEO";
    }
    return fileType;
  }

  OnMediaTypeUpload(mediaFile: {
    id: string;
    url: string;
    fileItem: FileItem;
  }) {
    let mediaFileProp = this._mediaTypeUpload(
      mediaFile.id,
      mediaFile.url,
      this._getfileType(mediaFile.url),
      mediaFile.fileItem
    );
    this.mediaFiles.push(mediaFileProp);
    this.updatePreview();
  }

  private imageSize(url: string) {
    const img = new Image();
    console.log("iscalled");
    img.src = url + this.DISABLE_CACHE;
    img.crossOrigin = "Anonymous";
    const promise: Promise<{
      width: number;
      height: number;
      imageUrl: string;
      base64URL: string;
    }> = new Promise((resolve, reject) => {
      img.onload = () => {
        // Natural size is the actual image size regardless of rendering.
        // The 'normal' `width`/`height` are for the **rendered** size.
        // img.src = url + this.DISABLE_CACHE;
        const width = img.width;
        const height = img.height;
        console.log(width, height, "imageSize function");
        // To convert the image to base64, use the following:
        let canvas = <HTMLCanvasElement>document.createElement("CANVAS"),
          ctx = canvas.getContext("2d"),
          base64URL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        base64URL = canvas.toDataURL("image/jpeg");
        canvas = null;
        // Resolve promise with the width and height
        width && height && resolve({ width, height, imageUrl: url, base64URL });
      };

      // Reject promise on error
      img.onerror = reject;
    });

    // Setting the source makes it start downloading and eventually call `onload`

    return promise;
  }

  async getImageDimension(imageURL: string) {
    const imageUrl = imageURL;
    try {
      const imageDimensions = await this.imageSize(imageUrl);
      const AR = imageDimensions.width / imageDimensions.height;
      console.info(imageDimensions); // {width: 1337, height: 42}
      return {
        size: imageDimensions,
        aspectRatio: this.getAspectRatio(
          imageDimensions.width,
          imageDimensions.height
        ),
        isWithinAspectRatio: this.isWithinAspectRatio(AR),
        imageUrl: imageDimensions?.imageUrl,
        base64URL: imageDimensions?.base64URL,
      };
    } catch (error) {
      console.log(error, "error");
    }
  }

  isWithinAspectRatio(ratio: number) {
    return ratio >= 0.8 && ratio <= 1.91;
  }

  getMinMaxDimension(isLandscape: boolean) {
    return {
      minWidth: 800,
      maxWidth: 1500,
      minHeight: isLandscape ? 600 : 1000,
      maxHeight: isLandscape ? 1800 : 1200,
    };
  }
  getImageMaxDimension(imageUrl: string) {
    let img = new Image();
    let width: number, height: number;
    img.src = imageUrl;
    let self = this;
    img.onload = (event) => {
      let loadedImage = event.currentTarget as HTMLImageElement;
      width = loadedImage.naturalWidth;
      height = loadedImage.naturalHeight;
      console.log("height: " + height);
      console.log("width: " + width);
      console.log("ar", width / height);
      console.log(this.isWithinAspectRatio(width / height));

      self.imageDimension = { width, height };
    };
    // W > H ? Landscape : portait
    console.log(width, height);
  }
  // private getImageMaxDimension(imageUrl: string) {
  //   let img = new Image();
  //   let width: number, height: number;
  //   img.src = imageUrl;
  //   let self = this;
  //   img.onload = (event) => {
  //     let loadedImage = event.currentTarget as HTMLImageElement;
  //     width = loadedImage.naturalWidth;
  //     height = loadedImage.naturalHeight;
  //     // self.imageDimension = { width, height };
  //   };
  //   // W > H ? Landscape : portait
  //   return { width, height };
  // }
  set imageDimension(dimension: { width: number; height: number }) {
    this._imageDimension = dimension;
  }
  get imageDimension() {
    return this._imageDimension;
  }
  gcd = (width: number, height: number) => {
    return height ? this.gcd(height, width % height) : width;
  };

  getAspectRatio = (width: number, height: number) => {
    const divisor = this.gcd(width, height);
    const aspectRatio = (width / divisor / (height / divisor)).toFixed(2);
    return aspectRatio;
  };

  transformCategoryToCTA(category: string) {
    switch (category) {
      case "Book_Appointment":
        return "book";
      case "Buy":
        return "buy";
      case "Events":
        return "events";
      case "Generic":
        return "none";
      case "Learn_More":
        return "learn_more";
      case "Order_Online":
        return "order_online";
      case "Signup":
        return "signup";

      default:
        break;
    }
  }

  transformCategoryName(values: string[], toCTA: boolean = false) {
    if (toCTA) {
      return values.map(
        (value: string) => this.transformCategoryToCTA(value)
        // value == "Signup" ? (value = "Sign Up") : value.replace("_", " ")
      );
    }
    return values.map((value: string) =>
      value == "Sign Up" ? (value = "Signup") : value.replace(" ", "_")
    );
  }

  transformSharePostType(values: string[]) {
    return values.map((value: string) => {
      switch (value) {
        case "email":
          return "Email";
        case "sms":
          return "SMS";
        default:
          break;
      }
    });
  }

  async checkIsFeatureApplicable(subFeature: keyof SocialSubFeatures) {
    return (
      await this.featuresByPlan.getFeature(this.socialFeature[subFeature])
    ).isApplicable();
  }

  async checkFeatureValues(
    subFeature: keyof SocialSubFeatures,
    value: string[],
    type: "category" | "share"
  ) {
    let subFeatureDetails: any = [...this.socialFeature[subFeature]];
    subFeatureDetails.push(
      type == "category" ? this.transformCategoryName(value) : value
    );
    let response = (
      await this.featuresByPlan.getFeature(subFeatureDetails)
    ).checkValues();
    return response;
  }

  getSocialSentItems(filters: {
    start: string;
    end: string;
    source?: string;
    post_type?: string;
  }) {
    return this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.SOCIAL_CALENDAR_LIST(this.outletId),
      start: filters.start,
      end: filters.end,
      source: filters.source,
      post_type: filters?.post_type,
    });
  }

  closeCalendar(close: boolean) {
    this.closeCalendarModal$.next(close);
  }

  public getConnectedPlatforms(): Observable<Response> {
    return this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.SOCIAL_AUTH_VERIFY_URL(this.outletId),
    });
  }

  public getBusinessLogo(): Observable<Response> {
    return this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.GET_LOGO_URL(this.outletId),
    });
  }

  public getReviewShareMetaData(): Observable<Response> {
    return this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.REVIEW_SHARE_META(this.outletId),
    });
  }

  public getReviewShareSettings(): Observable<Response> {
    return this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.REVIEW_SHARE_SETTINGS(this.outletId),
    });
  }

  public getReviewShareTemplates(filters?: {
    page?: string;
    size?: string;
    keyword?: string;
    isReviewShareTemplate?: number;
  }): Observable<Response> {
    return this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.SOCIAL_ZCEPPA_TEMPLATE(this.outletId),
      page: filters?.page,
      size: filters?.size,
      keyword: filters?.keyword,
      is_review_share_template: filters?.isReviewShareTemplate,
    });
  }

  public updateReviewSetting(payload: any): Observable<Response> {
    return this.HttpService.postRequest({
      customApiUrl: this.BASE_URL.REVIEW_SHARE_SETTINGS(this.outletId),
      data: payload,
    });
  }

  public getReviewForSharing(filters?: {
    page?: string;
    size?: string;
    keyword?: string;
    start_date?: string;
    end_date?: string;
  }): Observable<Response> {
    return this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.SOCIAL_SHARE_REVIEW(this.outletId),
      page: filters?.page,
      size: filters?.size,
      keyword: filters?.keyword,
      start_date: filters?.start_date,
      end_date: filters?.end_date,
    });
  }

  public addReviewsToSocialShare(payload: any): Observable<Response> {
    return this.HttpService.postRequest({
      customApiUrl: this.BASE_URL.ADD_REVIEW_SOCIAL_SHARE(this.outletId),
      data: payload,
    });
  }

  async checkFeatureValue(subFeature: keyof SocialSubFeatures) {
    let subFeatureDetails: any = [...this.socialFeature[subFeature]];
    let response = (
      await this.featuresByPlan.getFeature(subFeatureDetails)
    ).getDataValue();
    return response;
  }
}
